<template>
  <el-card class="h-full" :body-style="{ height: '100%', overflow: 'auto' }">
    <div>
      <el-input
        v-model.trim="searchData.name"
        size="small"
        placeholder="栏目名称"
        class="w-180px mr-10px"
        clearable
      ></el-input>

      <el-select
        v-model.trim="searchData.type"
        class="mr-10px"
        clearable
        popper-class="select-popper"
        placeholder="栏目类型"
      >
        <el-option
          v-for="(option, index) in columnTypeList"
          :key="index"
          :label="option.displayName"
          :value="option.id"
        ></el-option>
      </el-select>
      <el-select
        v-model.trim="searchData.category"
        class="mr-10px"
        clearable
        popper-class="select-popper"
        placeholder="栏目类别"
      >
        <el-option
          v-for="(option, index) in columnCategoryList"
          :key="index"
          :label="option.displayName"
          :value="option.id"
        ></el-option>
      </el-select>
      <el-select
        v-model.trim="searchData.source"
        class="mr-10px"
        clearable
        popper-class="select-popper"
        placeholder="栏目来源"
      >
        <el-option
          v-for="(option, index) in columnSourceList"
          :key="index"
          :label="option.displayName"
          :value="option.id"
        ></el-option>
      </el-select>
      <el-button type="primary" @click="onSearch">搜索</el-button>
      <el-button @click="handleClick('create')" type="primary" size="small">新增 </el-button>
    </div>
    <el-table
      height="calc(100%)"
      class="mt-20px"
      stripe
      :data="dispalyTabData"
      border
      row-key="id"
      :tree-props="{ children: 'child', hasChildren: 'isLeaf' }"
    >
      <el-table-column type="index" width="50" label="序号"></el-table-column>
      <el-table-column prop="name" show-overflow-tooltip label="栏目名称"></el-table-column>
      <el-table-column prop="parentId" width="200" label="栏目层级">
        <template slot-scope="scope">
          <div>{{ getLevelByParentId(scope.row.parentId) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="type" width="150" label="栏目类型">
        <template slot-scope="scope">
          <div>{{ getColumnType(scope.row.type) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="category" width="150" label="栏目类别">
        <template slot-scope="scope">
          <div>{{ getColumnCategory(scope.row.category) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="source" width="150" label="栏目来源">
        <template slot-scope="scope">
          <div>{{ getColumnSource(scope.row.source) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="remark" width="150" label="备注"></el-table-column>
      <el-table-column prop="creationTime" width="250" label="创建时间">
        <template slot-scope="scope">
          <div>{{ dayjs(scope.row.creationTime).format('YYYY-MM-DD HH:mm:ss') }}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="270" fixed="right">
        <template slot-scope="scope">
          <el-button @click="handleClick('edit', scope.row)" size="mini">编辑 </el-button>
          <el-button @click="singleRemove(scope.row)" size="mini">删除 </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :title="title"
      class="small-dialog"
      :visible.sync="postDialog"
      v-dialogDrag
      :before-close="closeDialog"
    >
      <div v-loading="submitLoading">
        <el-form label-width="150px" label-position="right" :model="form" ref="form">
          <el-row>
            <el-col :span="24" :offset="0">
              <el-form-item
                label="栏目名称"
                prop="name"
                :rules="[{ required: true, validator: checkName, trigger: 'blur' }]"
              >
                <el-input
                  v-model="form.name"
                  class="w-full"
                  maxlength="20"
                  placeholder="请输入栏目名称"
                  clearable
                  show-word-limit
                  @input="handleInputChange"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" :offset="0">
              <el-form-item label="上级栏目" prop="parentId">
                <el-select
                  v-model="form.parentId"
                  class="mr-10px"
                  clearable
                  popper-class="select-popper"
                  @change="handleInputChange"
                  filterable
                  placeholder="请选择上级栏目"
                >
                  <el-option
                    v-for="(option, index) in columnDataList"
                    :key="index"
                    :label="option.name"
                    :value="option.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24" :offset="0">
              <el-form-item label="是否叶子节点" prop="isLeaf">
                <el-radio-group v-model="form.isLeaf" @change="clearData">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

            <div v-if="form.isLeaf">
              <el-col :span="24" :offset="0">
                <el-form-item
                  label="栏目类型"
                  prop="type"
                  :rules="[{ required: form.isLeaf, message: '请选择栏目类型', trigger: 'change' }]"
                >
                  <el-select
                    v-model="form.type"
                    class="mr-10px"
                    clearable
                    popper-class="select-popper"
                    placeholder="请选择栏目类型"
                    @change="getValueForce"
                  >
                    <el-option
                      v-for="(option, index) in columnTypeList"
                      :key="index"
                      :label="option.displayName"
                      :value="option.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24" :offset="0">
                <el-form-item
                  label="栏目类别"
                  prop="category"
                  :rules="[{ required: form.isLeaf, message: '请选择栏目类别', trigger: 'change' }]"
                >
                  <el-select
                    v-model="form.category"
                    class="mr-10px"
                    clearable
                    popper-class="select-popper"
                    placeholder="请选择栏目类别"
                    @change="getValueForce"
                  >
                    <el-option
                      v-for="(option, index) in columnCategoryList"
                      :key="index"
                      :label="option.displayName"
                      :value="option.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24" :offset="0">
                <el-form-item
                  label="栏目来源"
                  prop="source"
                  :rules="[{ required: form.isLeaf, message: '请选择栏目来源', trigger: 'change' }]"
                >
                  <el-select
                    v-model="form.source"
                    class="mr-10px"
                    clearable
                    popper-class="select-popper"
                    placeholder="请选择栏目来源"
                    @change="getValueForce"
                  >
                    <el-option
                      v-for="(option, index) in columnSourceList"
                      :key="index"
                      :label="option.displayName"
                      :value="option.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24" :offset="0">
                <el-form-item
                  label="计入稿费统计"
                  prop="isComputeRoyalties"
                  :rules="[
                    { required: form.isLeaf, message: '请选择是否计入稿费统计', trigger: 'change' },
                  ]"
                >
                  <el-radio-group v-model="form.isComputeRoyalties">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="24" :offset="0">
                <el-form-item
                  label="展示侧边栏"
                  prop="isShowSidebar"
                  :rules="[
                    { required: form.isLeaf, message: '请选择是否展示侧边栏', trigger: 'change' },
                  ]"
                >
                  <el-radio-group v-model="form.isShowSidebar">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="24" :offset="0">
                <el-form-item
                  label="展示底部栏"
                  prop="isShowBottomSidebar"
                  :rules="[
                    { required: form.isLeaf, message: '请选择是否展示底部栏', trigger: 'change' },
                  ]"
                >
                  <el-radio-group v-model="form.isShowBottomSidebar">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="24" :offset="0">
                <el-form-item
                  label="稿件审批流程"
                  prop="workflow"
                  :rules="[
                    { required: form.isLeaf, message: '请选择稿件审批流程', trigger: 'change' },
                  ]"
                >
                  <el-radio-group v-model="form.workflow">
                    <el-radio :label="1">新闻稿件审批</el-radio>
                    <el-radio :label="2">业务稿件审批</el-radio>
                    <el-radio :label="0">无需审批</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </div>
            <el-col :span="24" :offset="0">
              <el-form-item
                label="排序号"
                prop="seqNo"
                :rules="[{ required: true, validator: checkSeq, trigger: 'blur' }]"
              >
                <el-input
                  v-model.number="form.seqNo"
                  class="w-full"
                  placeholder="请输入排序号"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" :offset="0">
              <el-form-item label="备注" prop="remark">
                <el-input
                  v-model="form.remark"
                  class="w-full"
                  maxlength="200"
                  show-word-limit
                  placeholder="请输入备注"
                  type="textarea"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" v-if="mode !== 'read'" class="flex justify-center items-center">
        <el-button type="primary" :loading="btnLoading" @click="handleSubmit">保存</el-button>
        <el-button @click="closeDialog()">取消</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import { ColumApi } from '@wiz-api/workbench'
import { DataCategoryApi } from '@wiz-api/data-category-management'

const columApi = new ColumApi()
const dataCategoryApi = new DataCategoryApi()
export default {
  data() {
    return {
      searchData: {
        name: '',
        type: '',
        category: '',
        source: '',
      },
      mode: '',
      title: '',
      submitLoading: false,
      loading: false,
      btnLoading: false,
      postDialog: false,
      tableData: [],
      dispalyTabData: [],
      columnCategory: '',
      columnCategoryList: [],
      columnType: '',
      searchDataList: [],
      columnTypeList: [
        {
          id: 1,
          displayName: '文字',
        },
        {
          id: 2,
          displayName: '图文',
        },
        {
          id: 3,
          displayName: '视频',
        },
      ],
      columnSourceList: [
        {
          id: 1,
          displayName: '门户栏目',
        },
        {
          id: 2,
          displayName: '外网栏目',
        },
      ],
      columnDataList: [],
      isExit: false,
      selectCategory: 'ColumnCategory',
      form: {},
    }
  },
  mounted() {
    this.getDataCategory()
    this.getTableData()
  },
  methods: {
    checkSeq(rule, value, callback) {
      if (!value && value !== 0) {
        callback(new Error('序号不能为空'))
        return
      }
      if (_.toString(value).length > 10) {
        callback(new Error('长度不能超过10个字符'))
        return
      }
      if (!_.isInteger(value) || value < 1) {
        callback(new Error('序号必须为大于0的正整数'))
        return
      }
      callback()
    },
    checkName(rule, value, callback) {
      if (!value && value !== '') {
        callback(new Error('请输入栏目名称'))
        return
      }
      if (this.isExit) {
        callback(new Error('栏目名称已存在'))
        return
      }
      callback()
    },
    getValueForce(val) {
      this.$nextTick(() => {
        this.$forceUpdate()
      })
    },
    clearData(value) {
      if (!value) {
        this.form.source = this.$options.data().form.source
        this.form.category = this.$options.data().form.category
        this.form.type = this.$options.data().form.type
      }
    },
    async getDataCategory() {
      this.columnCategoryList = []
      const [err, res] = await dataCategoryApi.getByCode({
        code: this.selectCategory,
        includeDetails: true,
      })
      if (!err) {
        this.columnCategoryList = res.dataItems
      }
    },
    async getTableData() {
      this.tableData = []
      this.dispalyTabData = []
      this.searchDataList = []
      this.columnDataList = []
      this.loading = true
      const [err, res] = await columApi.tree(0)
      if (!err && res) {
        this.loading = false
        this.tableData = res
        this.dispalyTabData = this.tableData
        this.tableData.forEach((element) => {
          this.getSearchDataList(element)
        })
      }
    },
    // 递归获取所有树的节点
    getSearchDataList(item) {
      if (item != null) {
        if (!item.isLeaf) {
          this.columnDataList.push({
            id: item.id,
            name: item.name,
          })
        }
        this.searchDataList.push(item)

        item?.child?.forEach((element) => {
          this.getSearchDataList(element)
        })
      }
    },
    getLevelByParentId(parentId) {
      let level = 0
      if (parentId != null) {
        level = level + 1
        this.searchDataList.forEach((element) => {
          if (parentId === element.id) {
            parentId = element.parentId
          }
        })
      }
      switch (level) {
        case 0:
          return '一级'
        case 1:
          return '二级'
        case 2:
          return '三级'
        case 3:
          return '四级'
        case 4:
          return '五级'
        case 5:
          return '六级'
        default:
          return ''
      }
    },
    getColumnCategory(id) {
      let displayName = ''
      this.columnCategoryList.forEach((element) => {
        if (element.id === id) {
          displayName = element.displayName
        }
      })
      return displayName
    },
    getColumnType(type) {
      let displayName = ''
      this.columnTypeList.forEach((element) => {
        if (element.id === type) {
          displayName = element.displayName
        }
      })
      return displayName
    },
    getColumnSource(type) {
      let displayName = ''
      this.columnSourceList.forEach((element) => {
        if (element.id === type) {
          displayName = element.displayName
        }
      })
      return displayName
    },
    onSearch() {
      const tempData = []
      this.searchDataList.forEach((element) => {
        let flag = true
        // 过滤名字
        if (this.searchData.name !== '' && !element.name.includes(this.searchData.name)) {
          flag = false
        }
        // 过滤类型
        if (this.searchData.type !== '' && element.type !== this.searchData.type) {
          flag = false
        }
        // 过滤类别
        if (this.searchData.category !== '' && element.category !== this.searchData.category) {
          flag = false
        }
        // 过滤来源
        if (this.searchData.source !== '' && element.source !== this.searchData.source) {
          flag = false
        }
        if (flag) {
          const item = _.cloneDeep(element)
          item.child = null
          item.parentId = null
          tempData.push(item)
        }
      })
      if (
        this.searchData.name === '' &&
        this.searchData.type === '' &&
        this.searchData.category === '' &&
        this.searchData.source === ''
      ) {
        this.dispalyTabData = this.tableData
      } else {
        this.dispalyTabData = tempData
      }
    },
    closeDialog(done) {
      this.form.name = this.$options.data().form.name
      this.isExit = false
      this.$refs.form.clearValidate()
      if (done) {
        done()
      } else {
        this.postDialog = false
      }
    },
    reset() {
      this.searchData = this.$options.data().searchData
    },
    async handleClick(mode, row) {
      this.mode = mode
      this.form = this.$options.data().form
      if (mode !== 'create') {
        this.form = _.cloneDeep(row)
        if (!this.form.isLeaf) {
          this.form.source = this.$options.data().form.source
          this.form.category = this.$options.data().form.category
          this.form.type = this.$options.data().form.type
        }
      }
      this.title = this.modeToTitle(mode)
      this.postDialog = true
    },
    modeToTitle(mode) {
      let title = ''
      switch (mode) {
        case 'edit':
          title = '编辑栏目'
          break
        case 'create':
          title = '新增栏目'
          break
        default:
          break
      }
      return title
    },
    // 单条数据删除
    singleRemove(row) {
      if (row.child?.length > 0) {
        this.$message.error('请先删除子栏目')
      } else {
        this.$confirm('此操作将永久删除该栏目，是否继续？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          const [err, res] = await columApi.callDelete({
            id: [row.id],
          })
          if (!err) {
            this.$message.success('删除栏目成功')
            this.getTableData()
          }
        })
      }
    },
    handleSubmit: _.debounce(function async() {
      this.submitLoading = true
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.btnLoading = true
          if (this.mode === 'create') {
            this.addPosition()
            return
          }
          this.editPosition()
        }
      })
      this.submitLoading = false
    }, 500),
    async addPosition() {
      const [err1, res1] = await columApi.add({ body: this.form })
      this.btnLoading = false
      if (!err1) {
        this.$message.success('新增栏目成功')
        this.postDialog = false
        this.getTableData()
      }
    },
    async editPosition() {
      const [err, res] = await columApi.update({ body: this.form })
      this.btnLoading = false
      if (!err) {
        this.$message.success('更新栏目成功')
        this.postDialog = false
        this.getTableData()
      }
    },
    handleInputChange: _.debounce(async function async() {
      // 检查名称是否已存在
      const [err, res] = await columApi.columnNameContains({
        name: this.form.name,
        columnType: this.form.type,
        parentId: this.form.parentId,
        id: this.form.id,
      })
      if (!err) {
        this.isExit = res
        this.$refs.form.validateField('name')
      }
    }, 500),
  },
}
</script>

<style lang="scss" scoped></style>
